export default __webpack_public_path__ + "static/media/program_intro_10.f0afb2a6.png";